import React from 'react'
import "./Aboutus2.css";

const OurSkills = () => {
    const skills = [
        { name: 'Network and Security', level: 70 },
        { name: 'Project Management', level: 80 },
        { name: 'Technology Consulting', level: 90 },
        { name: 'Advanced Virtualization', level: 100 }
      ];
  return (
    <> 
    <div className="skill-bars">
    <h2>Our Skills</h2>
    {skills.map((skill, index) => (
      <div className="skill-bar" key={index}>
        <div className="skill-name">{skill.name}</div>
        <div className="progress-bar">
          <div className="progress" style={{ width: `${skill.level}%` }}>
            <span className="progress-label">{skill.level}%</span>
          </div>
        </div>
      </div>
    ))}
  </div>  
  </>
  )
}

export default OurSkills